import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';
import Breadcrumb from '../../../components/feature/Breadcrumb';
import FAQSchema from '../../../components/feature/FAQSchema';
import { useEffect } from 'react';

export default function IstanbulAvrupaPage() {
  useEffect(() => {
    document.title = 'İstanbul Avrupa Yakası Fiber Optik ve Güvenlik Sistemleri | Fiber Ek';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'İstanbul Avrupa Yakası\'nda fiber optik altyapı, IP kamera, yangın alarm ve güvenlik sistemleri kurulumu. Profesyonel çözümler. ☎ +90 553 716 55 61');
    }

    // Canonical link
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = `${import.meta.env.VITE_SITE_URL}/bolgeler/istanbul-avrupa`;
    document.head.appendChild(canonical);

    // Open Graph tags
    const ogTitle = document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    ogTitle.content = 'İstanbul Avrupa Yakası Fiber Optik ve Güvenlik Sistemleri | Fiber Ek';
    document.head.appendChild(ogTitle);

    const ogDescription = document.createElement('meta');
    ogDescription.setAttribute('property', 'og:description');
    ogDescription.content = 'İstanbul Avrupa Yakası\'nda fiber optik altyapı, IP kamera, yangın alarm ve güvenlik sistemleri kurulumu. Profesyonel çözümler. ☎ +90 553 716 55 61';
    document.head.appendChild(ogDescription);

    const ogUrl = document.createElement('meta');
    ogUrl.setAttribute('property', 'og:url');
    ogUrl.content = `${import.meta.env.VITE_SITE_URL}/bolgeler/istanbul-avrupa`;
    document.head.appendChild(ogUrl);

    const ogType = document.createElement('meta');
    ogType.setAttribute('property', 'og:type');
    ogType.content = 'website';
    document.head.appendChild(ogType);

    const ogLocale = document.createElement('meta');
    ogLocale.setAttribute('property', 'og:locale');
    ogLocale.content = 'tr_TR';
    document.head.appendChild(ogLocale);

    // JSON-LD Schema
    const schema = document.createElement('script');
    schema.type = 'application/ld+json';
    schema.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Fiber Ek - İstanbul Avrupa Yakası",
      "description": "İstanbul Avrupa Yakası'nda fiber optik altyapı, IP kamera, yangın alarm ve güvenlik sistemleri kurulumu",
      "areaServed": "İstanbul Avrupa Yakası",
      "telephone": "+905537165561",
      "url": `${import.meta.env.VITE_SITE_URL}/bolgeler/istanbul-avrupa`,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "İstanbul",
        "addressRegion": "İstanbul",
        "addressCountry": "TR"
      }
    });
    document.head.appendChild(schema);

    return () => {
      document.head.removeChild(canonical);
      document.head.removeChild(ogTitle);
      document.head.removeChild(ogDescription);
      document.head.removeChild(ogUrl);
      document.head.removeChild(ogType);
      document.head.removeChild(ogLocale);
      document.head.removeChild(schema);
    };
  }, []);

  const faqs = [
    {
      question: 'İstanbul Avrupa Yakası\'nda fiber kablo tamiri ne kadar sürer?',
      answer: 'Acil fiber arıza durumlarında 30 dakika içinde müdahale ediyoruz. Basit fiber kablo tamiri işlemleri 1-2 saat içinde tamamlanırken, karmaşık fiber altyapı projeleri 1-3 gün sürebilir.'
    },
    {
      question: 'Fusion splicing hizmeti hangi bölgelerde veriliyor?',
      answer: 'Esenyurt, Başakşehir, Beylikdüzü, Avcılar, Küçükçekmece ve tüm İstanbul Avrupa Yakası ilçelerinde fusion splicing ve fiber optik sonlandırma hizmeti veriyoruz.'
    },
    {
      question: 'OTDR test nedir ve neden gereklidir?',
      answer: 'OTDR test, fiber optik kablolardaki kayıpları, kırılmaları ve bağlantı noktalarını tespit eden profesyonel bir ölçüm yöntemidir. Fiber altyapınızın sağlığını kontrol etmek ve arızaları önceden tespit etmek için kritik öneme sahiptir.'
    },
    {
      question: 'IP kamera sistemleri kurulumu ne kadar sürer?',
      answer: 'Küçük işletmeler için 4-8 kamera kurulumu 1 gün, orta ölçekli fabrikalar için 16-32 kamera kurulumu 2-3 gün, büyük sanayi tesisleri için kapsamlı güvenlik sistemleri 5-7 gün içinde tamamlanır.'
    }
  ];

  return (
    <>
      <FAQSchema faqs={faqs} />
      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900">
        <Navbar />
        <FloatingButtons />

        {/* Hero Section */}
        <section className="relative pt-32 pb-20 overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/3f5e1be4e6d87b393759ec8400b71e4d.jpg')] bg-cover bg-center opacity-20"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-blue-600/10 via-transparent to-slate-900/50"></div>
          
          <div className="container mx-auto px-4 relative z-10">
            <Breadcrumb 
              items={[
                { label: 'Ana Sayfa', path: '/' },
                { label: 'Bölgeler', path: '/' },
                { label: 'İstanbul Avrupa', path: '/locations/istanbul-avrupa' }
              ]} 
            />

            <div className="max-w-4xl mx-auto text-center mt-12">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
                İstanbul Avrupa Yakası Fiber Optik ve Güvenlik Sistemleri
              </h1>
              <p className="text-xl text-gray-300 mb-8">
                Esenyurt, Başakşehir, Beylikdüzü ve Tüm Avrupa Yakası'nda Profesyonel Fiber Kablo Tamiri, Fusion Splicing ve Güvenlik Çözümleri
              </p>
              <div className="flex flex-wrap gap-4 justify-center">
                <a 
                  href="tel:+905537165561"
                  className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap"
                >
                  <i className="ri-phone-line text-xl"></i>
                  Hemen Ara
                </a>
                <a 
                  href="https://wa.me/905537165561"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-20 bg-slate-800/50">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto">
              
              {/* Fiber Optik Hizmetleri */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                  <i className="ri-flashlight-line text-blue-500"></i>
                  İstanbul Avrupa Yakası Fiber Optik Hizmetleri
                </h2>
                
                <p className="text-gray-300 mb-6 leading-relaxed">
                  İstanbul Avrupa Yakası'nda <strong>fiber kablo tamiri</strong>, <strong>fiber optik sonlandırma</strong> ve <strong>fusion splicing hizmeti</strong> alanında 10+ yıllık tecrübemizle hizmet veriyoruz. Esenyurt, Başakşehir, Beylikdüzü, Avcılar, Küçükçekmece, Bahçelievler, Bağcılar ve çevre ilçelerde 7/24 <strong>acil fiber arıza</strong> müdahale ekibimiz hazır bekliyor.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Fiber Kablo Tamiri ve Acil Müdahale</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  İnşaat kazıları, yanlışlıkla kesilen fiber kablolar veya altyapı arızaları nedeniyle yaşanan internet kesintileri işletmeniz için büyük kayıplara yol açabilir. <strong>Fiber kablo tamiri</strong> konusunda uzman ekibimiz, Avrupa Yakası'nın her noktasına 30 dakika içinde ulaşarak arızanızı en kısa sürede giderir. <strong>OTDR test hizmeti</strong> ile fiber hattınızdaki kayıpları ve zayıf noktaları tespit eder, önleyici bakım önerileri sunarız.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Fusion Splicing ve Fiber Optik Sonlandırma</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  <strong>Fusion splicing hizmeti</strong> ile fiber optik kabloları mikron hassasiyetinde birleştiriyor, minimum kayıpla maksimum performans sağlıyoruz. <strong>SC LC konnektör sonlandırma</strong>, <strong>OM3 OM4 fiber ek</strong> işlemleri ve <strong>metro ethernet fiber ek</strong> projelerinde profesyonel çözümler sunuyoruz. Bina içi fiber altyapı kurulumlarından fabrika fiber altyapı projelerine kadar geniş yelpazede hizmet veriyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Bina ve Fabrika Fiber Altyapı</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  İstanbul Avrupa Yakası'ndaki sanayi bölgelerinde, iş merkezlerinde ve konut projelerinde <strong>bina fiber kablo tamiri</strong> ve <strong>fabrika fiber altyapı</strong> kurulumu gerçekleştiriyoruz. Özellikle Esenyurt OSB, Başakşehir İkitelli OSB ve Beylikdüzü sanayi bölgelerinde yoğun olarak çalışan ekibimiz, yüksek hızlı internet altyapısı için gerekli tüm fiber optik çözümleri sağlıyor.
                </p>

                <div className="grid md:grid-cols-2 gap-6 mt-8">
                  <Link to="/fiber-services/fiber-cable-repair" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-tools-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">Fiber Kablo Tamiri</h4>
                    <p className="text-gray-400 text-sm">Acil arıza müdahalei ve profesyonel tamir hizmeti</p>
                  </Link>
                  <Link to="/fiber-services/fiber-termination" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-link text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">Fusion Splicing</h4>
                    <p className="text-gray-400 text-sm">Hassas fiber ekleme ve sonlandırma işlemleri</p>
                  </Link>
                </div>
              </div>

              {/* Güvenlik Sistemleri */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                  <i className="ri-shield-check-line text-blue-500"></i>
                  Güvenlik Sistemleri ve IP Kamera Çözümleri
                </h2>
                
                <p className="text-gray-300 mb-6 leading-relaxed">
                  İstanbul Avrupa Yakası'nda <strong>IP kamera sistemleri</strong>, <strong>hırsız alarm sistemleri</strong>, <strong>yangın alarm sistemleri</strong> ve <strong>geçiş kontrol sistemleri</strong> kurulumu konusunda uzmanız. Fabrikalar, iş merkezleri, konut siteleri ve ticari işletmeler için entegre güvenlik çözümleri sunuyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">IP Kamera Sistemleri Kurulumu</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  Yüksek çözünürlüklü <strong>IP kamera sistemleri</strong> ile işletmenizi 7/24 güvence altına alıyoruz. Gece görüş özellikli kameralar, hareket algılama, uzaktan izleme ve kayıt sistemleri ile kapsamlı güvenlik sağlıyoruz. Esenyurt, Başakşehir ve Beylikdüzü'ndeki fabrika ve iş yerlerinde özel güvenlik projeleri gerçekleştiriyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Hırsız ve Yangın Alarm Sistemleri</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  <strong>Hırsız alarm sistemleri</strong> ile işyerinizi izinsiz girişlere karşı koruyoruz. Hareket sensörleri, kapı-pencere kontakları ve sesli uyarı sistemleri ile entegre çözümler sunuyoruz. <strong>Yangın alarm sistemleri</strong> kurulumlarında TSE standartlarına uygun duman dedektörleri, ısı sensörleri ve sesli uyarı sistemleri kullanıyoruz.
                </p>

                <h3 className="text-2xl font-bold text-white mb-4 mt-8">Geçiş Kontrol ve Bariyer Sistemleri</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">
                  <strong>Geçiş kontrol sistemleri</strong>, <strong>turnike sistemleri</strong> ve <strong>bariyer sistemleri</strong> ile fabrika ve iş merkezlerinizde personel ve araç giriş-çıkışlarını kontrol altına alıyoruz. Kartlı geçiş, parmak izi okuyucu ve plaka tanıma sistemleri ile güvenliği maksimum seviyeye çıkarıyoruz.
                </p>

                <div className="grid md:grid-cols-2 gap-6 mt-8">
                  <Link to="/security-systems/ip-camera-systems" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-camera-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">IP Kamera Sistemleri</h4>
                    <p className="text-gray-400 text-sm">Profesyonel güvenlik kamerası kurulumu</p>
                  </Link>
                  <Link to="/security-systems/access-control-systems" className="bg-slate-800/50 p-6 rounded-xl border border-slate-700/50 hover:border-blue-500/50 transition-all duration-300 group">
                    <i className="ri-door-lock-line text-3xl text-blue-500 mb-3 block"></i>
                    <h4 className="text-xl font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">Geçiş Kontrol Sistemleri</h4>
                    <p className="text-gray-400 text-sm">Turnike, bariyer ve kartlı geçiş çözümleri</p>
                  </Link>
                </div>
              </div>

              {/* Hizmet Verdiğimiz İlçeler */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-6">Hizmet Verdiğimiz İlçeler</h2>
                <div className="grid md:grid-cols-3 gap-4">
                  {['Esenyurt', 'Başakşehir', 'Beylikdüzü', 'Avcılar', 'Küçükçekmece', 'Bahçelievler', 'Bağcılar', 'Güngören', 'Esenler'].map((ilce) => (
                    <div key={ilce} className="bg-slate-800/30 p-4 rounded-lg border border-slate-700/30">
                      <i className="ri-map-pin-line text-blue-500 mr-2"></i>
                      <span className="text-gray-300">{ilce}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* FAQ */}
              <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-slate-700/50">
                <h2 className="text-3xl font-bold text-white mb-8">Sıkça Sorulan Sorular</h2>
                <div className="space-y-6">
                  {faqs.map((faq, index) => (
                    <div key={index} className="border-b border-slate-700/50 pb-6 last:border-0">
                      <h3 className="text-xl font-bold text-white mb-3">{faq.question}</h3>
                      <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="py-20 bg-slate-900/30">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-3xl font-bold text-white mb-8 text-center">Konum</h2>
              <div className="rounded-2xl overflow-hidden shadow-2xl border border-slate-700/50">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d385396.3210609283!2d28.68253!3d41.0082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b55f0a1b5c8c3d%3A0x3e6f8e3e3e3e3e3e!2zxLBzdGFuYnVsIEF2cnVwYSBZYWthc8Sx!5e0!3m2!1str!2str!4v1234567890"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="İstanbul Avrupa Yakası Harita"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}